import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getPaises, deletePais, changeStatusPais } from "../../../../api/pais";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";

function getData(paises) {
  let data = [];
  for (let i = 0; i < paises.length; ++i) {
    const elem = {};
    elem.name = paises[i].name;
    elem.code = paises[i].code;
    elem.prefix = paises[i].prefix;
    elem.createdAt = paises[i].createdAt;
    elem.id = paises[i]._id;
    elem.active = paises[i].active;
    data = data.concat(elem);
  }
  return data;
}

export default function PaisesPage() {
  const [data, setData] = useState([]);
  const [paisId, setPaisId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-pais/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setPaisId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Eliminar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setPaisId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "code", text: "Código ISO", sort: true },
    { dataField: "prefix", text: "Prefijo", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: () => {
        return { width: "160px", textAlign: "center" };
      },
    },
  ];

  useEffect(() => {
    getPaises()
      .then((res) => {
        if (res.status === 200) {
          setData(getData(res.data));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las paises.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Paises list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-pais")}
            >
              Añadir nueva
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table search={true} data={data} columns={columns} />
          <ConfirmDialog
            title={`¿Estás seguro de que quieres ${
              paisId?.active ? "desactivar" : "activar"
            } esta pais?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusPais(paisId.id, !paisId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        paisId?.active ? "¡Desactivada!" : "¡Activada!"
                      }`,
                      customMessage: `Pais ${
                        paisId?.active ? "desactivada" : "activada"
                      } correctamente`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se ha podido ${
                      paisId?.active ? "desactivar" : "activar"
                    } esta pais.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar esta pais?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deletePais(paisId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminada!",
                      customMessage: "Pais eliminada correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la pais.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
